module.exports = __webpack_public_path__ + "img/线下见面会-灰.aa27bba1.png";